import React, { Children } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { compose, withProps } from 'recompose';
import BaseObjectField from '../BaseObjectField';
import { withStyles } from 'material-ui/styles';
import Table, {
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from 'material-ui/Table';

const styles = theme => ({
  root: {
    borderCollapse: 'separate',
    tableLayout: 'fixed',
  },
  head: {
    color: theme.palette.text.hint,
    background: 'rgba(175, 175, 175, 0.1)',
    height: 30,
  },
  headRow: {
    height: 'inherit',
  },
  headCell: {
    height: 'inherit',
    verticalAlign: 'middle'
  },
  narrow: {
    width: '13.5%',
  },
  cellLabel: {
    width: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
});

const TableComponent = props => {
  const { classes, uiSchema, children } = props;

  const columns =
    uiSchema['ui:options'] && uiSchema['ui:options'].columns
      ? uiSchema['ui:options'].columns
      : [];

  const childrenWithColumns = Children.map(children, child =>
    React.cloneElement(child, {
      columns: Math.min(2, columns.length),
    })
  );

  return (
    <Table className={classes.root}>
      {columns.length > 0 && (
        <TableHead className={classes.head}>
          <TableRow className={classes.headRow}>
            {columns.map((prop, index) => {
              if (index > 1) return null;
              return (
                <TableCell
                  key={index}
                  padding="none"
                  className={classnames(classes.headCell, {
                    [classes.narrow]:
                      columns.length > 2 && index === columns.length - 1,
                  })}
                >
                  <div className={classes.cellLabel}>{prop}</div>
                </TableCell>
              );
            })}
          </TableRow>
        </TableHead>
      )}
      <TableBody>{childrenWithColumns}</TableBody>
    </Table>
  );
};

TableComponent.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array]),
  uiSchema: PropTypes.object,
  options: PropTypes.array,
};

const enhance = compose(
  withProps({
    RootComponent: withStyles(styles)(TableComponent),
  })
);

const TableField = enhance(BaseObjectField);

export default TableField;



// WEBPACK FOOTER //
// ./src/modules/common/components/form/fields/readonly/TableField.js